import type { LocationOccupancyMode } from './properties'

export type OccupancyUnit = 'hunters' | 'groups'

export function occupancyUnitFor(mode: LocationOccupancyMode): OccupancyUnit {
  return mode === 'groups' ? 'groups' : 'hunters'
}

export function occupancyUnitWord(unit: OccupancyUnit, count: number): string {
  if (unit === 'groups') return count === 1 ? 'party' : 'parties'
  return count === 1 ? 'hunter' : 'hunters'
}
